import { render, staticRenderFns } from "./Commissions.vue?vue&type=template&id=54d771de&scoped=true&"
import script from "./Commissions.vue?vue&type=script&lang=js&"
export * from "./Commissions.vue?vue&type=script&lang=js&"
import style0 from "./Commissions.vue?vue&type=style&index=0&id=54d771de&lang=scss&scoped=true&"
import style1 from "./Commissions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d771de",
  null
  
)

export default component.exports